import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import Accordion from "../../modules/Accordion/Accordion";
import DoNotMountComponent from "../../modules/DoNotMountComponent/DoNotMountComponent";
import Markdown from "../../modules/Markdown/Markdown";

type PropsSectionFaqs = PropsWithChildren<{
  data: Partial<Queries.SanityFaqs>;
  settings?: unknown;
}>;

const SectionFaqs: React.FC<PropsSectionFaqs> = (props: PropsSectionFaqs) => {
  const { t } = useTranslation("global");
  if (!props.data.title || !props.data?.faqsList || !Array.isArray(props.data.faqsList))
    return <DoNotMountComponent sms={"SectionFaqs"} log={props} />;
  return (
    <section className={`o-section-faqs`}>
      <div className={`c-section-faqs`}>
        <div className="section-faqs-headline">
          <h2 className="a-title">{props.data.title}</h2>
        </div>
        <div className="section-faqs__list">
          {props.data?.faqsList?.map((faq, index) => {
            return <Accordion resume={{ title: faq.question, text: faq.answer }} key={index} />;
          })}
        </div>
      </div>
      <div className="section-faqs-logo">
        <p className="section-faqs__text">{`${t("Con la garantía de:")}`}</p>
        <div className="section-faqs__img">
          <StaticImage src={"./logo-coaatz.png"} alt={t("logo COAATZ")} />
        </div>
      </div>
    </section>
  );
};

export { SectionFaqs };
